// extracted by mini-css-extract-plugin
module.exports = {"container":"_31ZbJHQcEbwpRNVgP5rm64","tableOfContents":"cZ7xEV_QB5MivT_RH764X","name":"_1rUGNUm__R69i-ajTviK1w","type":"J4vHu4XVypAzFCZFU7kWR"};